import React, { useState } from 'react';
import { Acorn } from '../../models/acorn';

interface EditAcornProps {
  acorn: Acorn;
  onSave: (updatedAcorn: Acorn) => void;
  onCancel: () => void;
}

const EditAcorn: React.FC<EditAcornProps> = ({ acorn, onSave, onCancel }) => {
  const [updatedAcorn, setUpdatedAcorn] = useState<Acorn>(acorn);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setUpdatedAcorn({ ...updatedAcorn, [name]: name === "Points" ? Number(value) : value });
  };

  const handleSave = () => {
    onSave(updatedAcorn);
  };

  return (
    <div className="max-w-md mx-auto bg-white p-6 rounded-lg shadow-md">
      <h2 className="text-2xl font-bold mb-4">Edit Acorn</h2>
      
      <div className="mb-4">
        <label className="block text-gray-700 font-medium mb-1">Code:</label>
        <input
          type="text"
          name="Code"
          value={updatedAcorn.code}
          onChange={handleChange}
          className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:border-blue-500"
        />
      </div>
      
      <div className="mb-4">
        <label className="block text-gray-700 font-medium mb-1">Points:</label>
        <input
          type="number"
          name="Points"
          value={updatedAcorn.points}
          onChange={handleChange}
          className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:border-blue-500"
        />
      </div>
      
      <div className="mb-4">
        <label className="block text-gray-700 font-medium mb-1">Description:</label>
        <input
          type="text"
          name="AcornDescription"
          value={updatedAcorn.acornDescription}
          onChange={handleChange}
          className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:border-blue-500"
        />
      </div>
      
      <div className="flex justify-end space-x-4">
        <button
          onClick={handleSave}
          className="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded"
        >
          Save
        </button>
        <button
          onClick={onCancel}
          className="bg-gray-500 hover:bg-gray-600 text-white font-semibold px-4 py-2 rounded"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default EditAcorn;
